import { logout_event } from "@/utils/gtm";
import { deleteCookie } from "cookies-next";
import { signOut } from "next-auth/react";

export const handleSignOut = (
  push,
  dispatchCart,
  dispatchCheckout,
  session
) => {
  logout_event(
    decodeURIComponent(session?.user?.email),
    decodeURIComponent(
      session?.user?.custom_attributes?.find(
        (item) => item?.attribute_code.includes("mobile") && !!item?.value
      )?.value
    ),
    decodeURIComponent(session?.user?.firstname),
    decodeURIComponent(session?.user?.lastname)
  );
  deleteCookie("quote");
  deleteCookie("mage");
  dispatchCart({ type: "clear" });
  dispatchCheckout({ type: "clear" });
  signOut({ redirect: false });
  push("/");
};
